import axios from 'axios';
import { LoaderFunctionArgs } from 'react-router-dom';
import { apiGateway } from 'src/config';
import { OrganizationEntity } from 'src/features/general/enquete-answer/store/enqueteAnswerSlice';
import { IdIssuancePage } from '../pages/IdIssuancePage';

export type VerifyTokenResponse = {
  organizations: OrganizationEntity[];
};

export const idIssuanceRoute = {
  path: 'pending-respondent',
  loader: async ({ request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const token = url.searchParams.get('token');
    if (!token) {
      throw new Response('Token is required', { status: 404 });
    }
    try {
      const response = await axios.get<VerifyTokenResponse>(`${apiGateway}/pending-respondent/verify?token=${token}`, {
        timeout: 60000,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch {
      throw new Response('Not Found', { status: 404 });
    }
  },
  element: <IdIssuancePage />,
};

export default idIssuanceRoute;
